import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  footerContainer: {
    position: 'relative',
    bottom: '0',
    // height:'2.5rem'
  }
}));